/**
 * QueryClient Configuration
 *
 * Singleton QueryClient instance for @tanstack/react-query.
 * Shared across the entire application.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,       // 5 min default
      gcTime: 30 * 60_000,          // 30 min garbage collection
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
